import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env';
import { SmsRichCampainStatistic, Value } from '@models/sms/rich-sms-details';
import { RichSmsDetailsService } from '@services/rich-sms-details.service';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
// import { Color, Label, MultiDataSet } from 'ng2-charts';

@Component({
  selector: 'wsb-device-statistics',
  templateUrl: './device-statistics.component.html',
  styleUrls: ['./device-statistics.component.scss'],
  standalone: false
})
export class DeviceStatisticsComponent implements OnInit {
  @Input() uuidMessage: string;

  campainStats: SmsRichCampainStatistic = new SmsRichCampainStatistic();

  testStats = new Map<any, any>();

  public doughnutChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  public doughnutChartData = [
    {
      data: [350],
      label: '',
      offset: '10px',
      spacing: '10px'
    }
  ];
  public doughnutChartType: ChartType = 'doughnut';

  public doughnutLegend = false;
  public doughnutType: ChartType = 'doughnut';
  public doughnutLabels: string[] = [];
  public doughnutOptions?: ChartOptions<'doughnut'> = {
    responsive: true,
    cutout: 90
  };
  public doughnutColors: any[] = [
    {
      backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
      pointBorderColor: environment.chartsColorPalette[2],
      pointHoverBorderColor: environment.chartsColorPalette[3]
    }
  ];
  public doughnutDesktopData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutTabletData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutSmartphoneData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };
  public doughnutOthersData: ChartData<'doughnut'> = {
    datasets: [
      {
        data: [0, 1],
        label: '',
        backgroundColor: [environment.chartsColorPalette[0], '#f3f3f3'],
        borderColor: environment.chartsColorPalette[2],
        hoverBorderColor: environment.chartsColorPalette[3]
      }
    ]
  };

  desktop: Value;
  smartphone;
  tablet;
  other;
  total;

  constructor(private richSmsDetailService: RichSmsDetailsService) {}

  ngOnInit(): void {
    if (this.uuidMessage) {
      this.getDeviceStats(this.uuidMessage);
    }
  }

  getDeviceStats(uuid) {
    this.richSmsDetailService.getSmsRichCampainStatistics(uuid).subscribe(stats => {
      this.campainStats = stats;

      for (const [key, value] of Object.entries(stats.device)) {
        switch (key) {
          case 'Desktop':
            this.desktop = { ...this.desktop, ...value };
            this.doughnutDesktopData.datasets[0].data = [this.desktop.clicks, this.campainStats.total - this.desktop.clicks];
            break;
          case 'Mobile':
            this.smartphone = value;
            this.doughnutSmartphoneData.datasets[0].data = [this.smartphone.clicks, this.campainStats.total - this.smartphone.clicks];
            break;
          case 'Tablet':
            this.tablet = value;
            this.doughnutTabletData.datasets[0].data = [this.tablet.clicks, this.campainStats.total - this.tablet.clicks];
            break;
          case 'Unknown':
            this.other = value;
            this.doughnutOthersData.datasets[0].data = [this.other.clicks, this.campainStats.total - this.other.clicks];
            break;
          default:
            break;
        }
      }
    });
  }
}
